<template>
  <div class="project-explain" id="project-explain">
    <!-- <van-nav-bar
      :title="navTitle"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
    /> -->
    <div class="project-explain-box">
      <div class="box-top">
        <div class="top-title">
          {{ componentData.DKBT }}
        </div>
        <div class="top-content">
          {{ componentData.DYBFSM }}
        </div>
      </div>

      <div class="box-content">
        <div class="box-title">{{ componentData.DEBFSMBT }}</div>
        <div class="content">
          <div
            class="content-text"
            v-for="(item) in cxTable"
            :key="Number(item.id)"
          >
            {{ item.value }}
          </div>
        </div>
        <div class="content-footer">
          <van-icon name="info-o" color='#ffa403'/> {{ componentData.DSBFSM }}
        </div>
      </div>
      <div class="box-footer">
        <van-button
          :class="checked ? 'btn' : 'no-btn'"
          block
          @click="appointStart"
          >下一步</van-button>
          <appoint-checkbox class="checkbox" v-model="checked">{{
          componentData.GXKWZ
        }}</appoint-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import appointCheckbox from "@/components/ProjectAppoint/appoint-checkbox";
import moduleMixins from "@/mixins/moduleMixins";
import appointMixins from "@/mixins/appointMixins";
export default {
  name: "ShowProtocol",
  components: { appointCheckbox },
  mixins: [moduleMixins, appointMixins],
  props: {},
  data() {
    return {
      checked: false,
      rid: "",
    };
  },
  watch: {},
  computed: {
    // ...mapGetters('form', ['getFormData']),
    navTitle() {
      // return this.componentData ? this.componentData.WTSM : "委托说明书";
      return "委托说明"
    },
    cxTable(){
      let list= []
      for(let i=0;i<this.componentData.cxTable?.length;i++){
        const element= this.componentData.cxTable[i]
        const id = Number(element.id) 
        list[id-1]=element
      }
      return list
    }
  },
  methods: {
    appointStart() {
      if (this.checked) {
        this.toNext();
      }
    },
    toNext() {
      this.$router.push({
        name: "CommonFormFinal",
      });
    },
  },
  created() {},
  mounted() {
    // this.componentData = this.getFormData('XMWT')
  },
};
</script>
<style lang="scss" scoped>
.project-explain {
  height: 100vh;
  background: #ffffff;
  .project-explain-box {
    background: #ffffff;
    .box-top {
      padding: 0px 16px;
      .top-title {
        text-align: center;
        padding-top: 30px;
        font-size: 21px;
        font-weight: bold;
        color: #333333;
      }
      .top-content {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        padding-top: 16px ;
      }
    }
    .box-content {
      padding: 0px 16px;
      margin-top: 30px;
      padding-bottom: 150px;
      .box-title {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
      }
      .content-title {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
      }
      .content {
        background: #efefef80;
        padding: 22px 16px;
      }
      .content-text {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 21px;
      }
      .content-footer {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        margin-top: 16px;
      }
    }
    .box-footer {
      width: calc(100% - 20px);
      background: #ffffff;
      bottom: 0;
      position: fixed;
      padding: 0px 10px 10px 10px;

      .checkbox {
        align-items: flex-start;
        padding: 10px 10px 0px 10px;
        ::v-deep .van-checkbox__label {
          font-size: 12px;
          font-weight: 500;
          color: #333333;
          line-height: normal;
        }
      }
      .no-btn {
        background: #cfcfcf;
        box-shadow: 0px 2px 6px 0px rgba(207, 207, 207, 0.5);
        border-radius: 5px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        padding: 14px 0;
        text-align: center;
        border: 1px solid transparent;
        padding: 20px 10px;
      }
      .btn {
        background: #0086ff;
        box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
        border-radius: 5px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        padding: 14px 0;
        text-align: center;
        border: 1px solid transparent;
        padding: 20px 10px;
      }
    }
  }
}
</style>
